// Xero's raw Invoice.Status API values (DRAFT/SUBMITTED/AUTHORISED/PAID/
// VOIDED/DELETED - see developer.xero.com) get stored verbatim as
// InvoiceStatus.name (xero-import-service.js's resolveInvoiceStatuses), but
// that's not the wording Xero's own UI shows for them - anyone who's used
// Xero directly sees "Awaiting Approval"/"Awaiting Payment" there, not
// "Submitted"/"Authorised". This maps the raw synced name to Xero's actual
// UI label wherever a status is displayed, without touching the stored data
// itself (custom, company-created statuses pass through unchanged).
const XERO_STATUS_LABELS: Record<string, string> = {
    DRAFT: 'Draft',
    SUBMITTED: 'Awaiting Approval',
    AUTHORISED: 'Awaiting Payment',
    PAID: 'Paid',
    VOIDED: 'Voided',
    DELETED: 'Deleted',
};

// Xero itself only surfaces Voided/Deleted under an explicit "include
// deleted & voided" view, not as one of its normal status tabs (Draft,
// Awaiting Approval, Awaiting Payment, Paid) - mirrored here for the
// Invoices page's default status selection.
export const XERO_HIDDEN_BY_DEFAULT = new Set(['VOIDED', 'DELETED']);

export const isXeroSystemStatus = (rawName?: string | null): boolean =>
    !!rawName && Object.prototype.hasOwnProperty.call(XERO_STATUS_LABELS, rawName.trim().toUpperCase());

export const formatInvoiceStatusLabel = (rawName?: string | null): string => {
    if (!rawName) return '';
    const key = rawName.trim().toUpperCase();
    return XERO_STATUS_LABELS[key] || rawName;
};
